import feedNaming from '../../utils/feedNaming';
import { processAccordingPostType } from '../../utils/processAccordingPostType';

export default (data, type) => {
  const dataFeeds = feedNaming[type] ?
    Object.keys(feedNaming[type]).map(key => data[key]) :
    [];
  switch (type) {
    case 'threads':
      return { feedsToUpdate: ['threads'], dataFeeds };
    case 'messages':
      return { feedsToUpdate: [feedNaming.threads.messages(data.thread)], dataFeeds };
    case 'posts':
      const superParentPostFeedsToUpdate = [
        feedNaming.groups.posts(data.group),
        feedNaming.users.posts(data.author),
      ];
      const feedsToUpdate = processAccordingPostType(data, {
        blog: superParentPostFeedsToUpdate,
        poll: superParentPostFeedsToUpdate,
      }) || [feedNaming.users.replies(data.author)];

      return { feedsToUpdate, dataFeeds };
    default:
      return { feedsToUpdate: [], dataFeeds };
  }
};



// WEBPACK FOOTER //
// ./~/virgo/src/reducers/feeds/getDependencies.js